import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { DoloresSection } from '../components/sections/DoloresSection';
import { BeneficiosSection } from '../components/sections/BeneficiosSection';
import { RecipeCategoriesSection } from '../components/sections/RecipeCategoriesSection';
import { BonusSection } from '../components/sections/BonusSection';
import { PriceSection } from '../components/sections/PriceSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { ReviewsSection } from '../components/sections/ReviewsSection';
import { FAQSection } from '../components/sections/FAQSection';
import { SectionDivider } from '../components/SectionDivider';
import { UrgencyBar } from '../components/UrgencyBar';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-ancestral-cream font-sans text-ancestral-dark" data-id="element-505">
      {/* Barra de urgencia sticky */}
      <UrgencyBar data-id="element-506" />

      {/* A) Promesa */}
      <HeroSection data-id="element-507" />

      {/* B) Dolores */}
      <DoloresSection data-id="element-508" />

      {/* C) Beneficios */}
      <BeneficiosSection data-id="element-509" />

      {/* D) ¿Qué obtengo de este libro? */}
      <RecipeCategoriesSection data-id="element-510" />

      {/* D.5) Bonos de regalo */}
      <BonusSection data-id="element-511" />

      {/* E) Precio */}
      <PriceSection data-id="element-512" />

      {/* F) Garantía */}
      <GuaranteeSection data-id="element-513" />

      {/* F.5) Reseñas */}
      <ReviewsSection data-id="element-514" />
      <SectionDivider color="green" className="bg-ancestral-cream" data-id="element-515" />

      {/* G) Preguntas Frecuentes */}
      <FAQSection data-id="element-516" />

      {/* Footer */}
      <Footer data-id="element-517" />

      {/* Social proof toasts */}
      <RecentPurchaseToast data-id="element-518" />
    </main>;
}